import React from 'react';
import { Chip, ChipProps } from '@mui/material';

interface DebugStatusChipProps {
  /** HTTP status code */
  status?: number;
  /** Error message (takes precedence over status) */
  error?: string;
  /** Size of the chip */
  size?: 'small' | 'medium';
}

/**
 * Color-coded status chip for HTTP response status
 */
const DebugStatusChip: React.FC<DebugStatusChipProps> = ({
  status,
  error,
  size = 'small',
}) => {
  let color: ChipProps['color'] = 'default';
  let label = 'Unknown';

  if (error) {
    color = 'error';
    label = 'Error';
  } else if (status !== undefined) {
    label = String(status);

    if (status >= 200 && status < 300) {
      color = 'success';
    } else if (status >= 300 && status < 400) {
      color = 'info';
    } else if (status >= 400 && status < 500) {
      color = 'warning';
    } else if (status >= 500) {
      color = 'error';
    }
  }

  return (
    <Chip
      label={label}
      color={color}
      size={size}
      sx={{
        fontWeight: 'bold',
        minWidth: 50,
      }}
    />
  );
};

export default React.memo(DebugStatusChip);
